<template>
  <div class="">
    <Header></Header>
    <div class="page-container">
      <div class="page-wrapper">
        <div class="card-container">
          <div class="card-wrapper">
            <div class="card-header">
              {{ examData.title }}
              <div class="card-header-line"></div>
            </div>
            <div class="card-content-container">
              <div class="card-content-wrapper">
                <div class="score-num-wrapper">
                  <div class="score-img-wrapper">
                    <img src="@/assets/img/score.png" alt="" class="score-img" />
                  </div>
                  <div class="score-num">
                    <span>{{ examData.score }}</span>
                    <span class="score-num-unit">分</span>
                  </div>
                </div>
                <div class="score-info-wrapper">
                  <div class="score-info-date-time">
                    交卷时间 {{ examData.userExamEndTime }}
                  </div>
                  <div class="score-info-date-long">
                    做题时长 {{ resetTimes(examData.userSpendTime) }}
                  </div>
                  <div class="score-info-list-wrapper">
                    <div class="score-info-list-item">
                      <div class="score-info-list-title">共做</div>
                      <div class="score-info-list-value">
                        {{ examData.doTotal }}
                      </div>
                    </div>
                    <div class="score-info-line"></div>
                    <div class="score-info-list-item">
                      <div class="score-info-list-title">做对</div>
                      <div class="score-info-list-value">
                        {{ examData.correct }}
                      </div>
                    </div>
                    <div class="score-info-line"></div>
                    <div class="score-info-list-item">
                      <div class="score-info-list-title">做错</div>
                      <div class="score-info-list-value">
                        {{ examData.error }}
                      </div>
                    </div>
                    <div class="score-info-line"></div>
                    <div class="score-info-list-item">
                      <div class="score-info-list-title">未做</div>
                      <div class="score-info-list-value">
                        {{ examData.undo }}
                      </div>
                    </div>
                  </div>
                  <div class="score-info-btn-wrapper">
                    <!-- <div class="score-info-btn" @click="handleView('analysis')">查看全部解析</div>
                                        <div class="score-info-btn" @click="handleView('error')">查看错题</div>
                                        <div class="score-info-btn" @click="handleStudyPlan">返回计划列表</div> -->
                  </div>
                </div>
              </div>
            </div>

            <div class="table-container">
              <div class="table-title">本次练习</div>
              <div class="table-wrapper">
                <table border>
                  <tr class="table-header">
                    <td>题型</td>
                    <td>正确</td>
                    <td>错误</td>
                    <td>已做</td>
                    <td>正确率</td>
                  </tr>
                  <tr v-for="(item, key) in examData.examResultList" :key="key">
                    <td>
                      <span v-if="item.questionType == 1">单选题</span>
                      <span v-if="item.questionType == 2">多选题</span>
                      <span v-if="item.questionType == 3">判断题</span>
                    </td>
                    <td>{{ item.correct }}</td>
                    <td>{{ item.error }}</td>
                    <td>{{ item.done }}/{{ item.total }}</td>
                    <td>{{ item.correctRate }}</td>
                  </tr>
                </table>
              </div>
              <div class="table-btn-wrapper">
                <div class="table-btn" @click="handleView('analysis')">
                  查看全部解析
                </div>
                <div class="table-btn" @click="handleView('error')">
                  查看错题
                </div>
                <div class="table-btn" @click="handleStudyPlan">
                  返回计划列表
                </div>
                <div v-if="examData.remainingTimes > 0 && examData.isRetest" class="table-btn"
                  @click="handleResetExercise">
                  重新测试
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
export default {
  name: "",
  components: {
    Header,
  },
  data() {
    return {
      examData: {
        isRetest: true,
      },
    };
  },
  mounted() {
    this.examData = JSON.parse(window.localStorage.getItem("score"));
  },
  methods: {
    handleStudyPlan() {
      this.$router.go(-1);
      // this.$router.push("/");
    },
    handleResetExercise() {
      var examData = this.examData;
      var exerciseData = JSON.parse(window.localStorage.getItem("exercise"));
      exerciseData["mode"] = "partEdit";
      this.$router.push(`/exercise/${examData.palnId}/${examData.metaExamId}`);
    },
    resetTimes(time) {
      var hours = parseInt(time / 3600);
      var hoursRum = time % 3600;
      var minutes = parseInt(hoursRum / 60);
      var seconds = hoursRum % 60;
      if (hours < 10) {
        hours = "0" + hours;
      }
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      if (seconds < 10) {
        seconds = "0" + seconds;
      }
      return `${hours}:${minutes}:${seconds}`;
    },
    handleView(mode) {
      var examData = this.examData;
      var exerciseData = JSON.parse(window.localStorage.getItem("exercise"));
      var targetMode = exerciseData.mode;
      switch (mode) {
        case "error":
          if (targetMode == "partEdit") {
            exerciseData["mode"] = "partError";
          }
          if (targetMode == "totalEdit") {
            exerciseData["mode"] = "totalError";
          }
          break;
        case "analysis":
          if (targetMode == "partEdit") {
            exerciseData["mode"] = "partAnalysis";
          }
          if (targetMode == "totalEdit") {
            exerciseData["mode"] = "totalAnalysis";
          }
          break;
      }
      window.localStorage.setItem("exercise", JSON.stringify(exerciseData));
      this.$router.push(`/exercise/${examData.palnId}/${examData.metaExamId}`);
    },
  },
};
</script>

<style scoped>
.page-container {
  width: 100%;
  margin: 0 auto;
}

.page-wrapper {
  width: 1200px;
  margin: 0 auto;
  padding: 100px;
}

.card-container {
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #eaeaea;
  display: flex;
  margin-top: 18px;
  position: relative;
}

.card-wrapper {
  flex: 1;
  margin: 30px 45px 0px 45px;
}

.card-header {
  font-size: 24px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #3e63ee;
  position: relative;
}

.card-header-line {
  width: 6px;
  height: 24px;
  background: #3e63ee;
  border-radius: 3px;
  position: absolute;
  left: -45px;
  top: 5px;
}

.card-content-container {
  margin-top: 62px;
  padding-bottom: 54px;
  border-bottom: 1px solid #f0f0f0;
}

.card-content-wrapper {
  width: 808px;
  margin: 0 auto;
  display: flex;
}

.score-num-wrapper {
  width: 157px;
  height: 211px;
  position: relative;
}

.score-img-wrapper {
  width: 157px;
  height: 211px;
}

.score-img {
  width: 100%;
  height: 100%;
}

.score-num {
  font-size: 42px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #3e63ee;
  position: absolute;
  left: 40px;
  bottom: 35px;
}

.score-num-unit {
  font-size: 22px;
  color: #606a74;
  position: relative;
  left: 3px;
  top: -4px;
}

.score-info-wrapper {
  flex: 1;
  margin-left: 87px;
}

.score-info-date-time {
  font-size: 22px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  margin-bottom: 10px;
}

.score-info-date-long {
  font-size: 22px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
}

.score-info-list-wrapper {
  display: flex;
  margin-top: 25px;
  justify-content: space-between;
}

.score-info-list-title {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #606a74;
}

.score-info-list-value {
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #606a74;
  margin-top: 5px;
}

.score-info-line {
  width: 1px;
  height: 35px;
  background: #e4e4e4;
  margin-left: 42px;
  margin-right: 42px;
  position: relative;
  top: 10px;
}

.score-info-btn-wrapper {
  display: flex;
  margin-top: 27px;
}

.score-info-btn {
  height: 40px;
  border-radius: 6px;
  border: 1px solid #3e63ee;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #3e63ee;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px 18px 0px 18px;
  transition: 0.5s;
  transition-property: all;
  transition-duration: 0.5s;
  transition-timing-function: ease;
  transition-delay: 0s;
  margin-right: 20px;
}

.score-info-btn:hover {
  cursor: pointer;
  background: #3e63ee;
  color: #fff;
}

.table-container {
  width: 808px;
  margin: 0 auto;
  margin-top: 40px;
  padding-bottom: 77px;
}

.table-title {
  font-size: 22px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
}

.table-wrapper {
  width: 100%;
  margin-top: 34px;
}

table {
  width: 100%;
  border: 1px solid #cbcbcb;
  border-collapse: collapse;
}

td {
  height: 60px;
  font-size: 22px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #606a74;
  text-align: center;
}

.table-header td {
  font-size: 22px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  background: rgb(248, 248, 248);
}

.table-btn-wrapper {
  display: flex;
  justify-content: end;
  margin-top: 50px;
}

.table-btn {
  height: 40px;
  border-radius: 6px;
  border: 1px solid #3e63ee;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #3e63ee;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px 18px 0px 18px;
  transition: 0.5s;
  transition-property: all;
  transition-duration: 0.5s;
  transition-timing-function: ease;
  transition-delay: 0s;
  margin-left: 20px;
}

.table-btn:hover {
  cursor: pointer;
  background: #3e63ee;
  color: #fff;
}
</style>


